var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"sidebar desktopView"},[_c('ProfileSidebarComponent')],1),_c('div',{staticClass:"main container-fluid"},[_c('router-view')],1)]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }